<table datatable class="table bg-white align-middle effects-table">
    <thead *ngIf="showHeader">
        <tr>
            <th>{{'Determinant' | translate}}</th>
            <th>{{'Has effect on' | translate}}</th>
            <th class="text-center cell-delete">&nbsp;</th>
        </tr>
        <tr><th></th><th></th><th></th></tr>
    </thead>
    <tbody>
        <tr>
            <td><div class="workarea__draghere"><div class="editBtn text-dark" (click)="openBuilder()">Select</div></div></td>
            <td class="">
                <select class="form-control form-control-sm" id="inputGroupSelect04" aria-label="Action" [(ngModel)]="determinantRow.type">
                    <option [ngValue]="0" selected disabled>Select</option>
                    <!--<option [ngValue]="1">Bot</option>-->
                    <option [ngValue]="2">Copy value from</option>
                    <option [ngValue]="3">Default value</option>
                    <option [ngValue]="3">Formula</option>
                </select>
                <div *ngIf="determinantRow.type === 2" class="d-inline-block ml-2">
                    <div class="d-flex">
                        <div class="w-100">
                            <div class="list-group list-group--slim">
                                <ng-select bindLabel="text"
                                        bindValue="id"
                                        [clearable]="false"
                                        [multiple]="true"
                                        placeholder="Select field(s)"></ng-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="determinantRow.type === 3" class="d-inline-block ml-2">
                    <input class="form-control form-control-sm" placeholder="Default value">
                </div>
            </td>
            <td class="cell-delete"><i class="btn-xs btn-bordered btn-danger btn-icon fas fa-times"></i></td>
        </tr>
    </tbody>
    <tfoot>
        <tr>
            <th colspan="3" class="text-left">
                <div class="d-inline-block btn btn-link btn-sm">
                    <i class="fa fa-plus mr-2"></i>
                    <span>{{'Effect on field content' | translate}}</span>
                </div>
            </th>
        </tr>
    </tfoot>
</table>

<drawer [title]="'blabla'" [isClosed]="isManageDetsClosed" [embedded]=true (closeEvent)="closeBuilder();" class="text-left">
    <div class="row drawer-content drawer-direct-content">
        <determinant-manager
            *ngIf="serviceId"
            [serviceId]="serviceId"
            [jsonString]="selectedDeterminant"
            [showBuilder]=true
            (cancel)="closeBuilder()"
            class="col">
        </determinant-manager>
    </div>
</drawer>

